import React from "react";
import Zaklad from "./Zaklad";

export default function ZakladPage(props) {
  return <Zaklad {...props} />;
}
